import {
  SET_SEARCH_TYPE,
  SEARCH_PATIENT_BY_NAME,
  SEARCH_PATIENT_BY_NUMBER,
  SEARCH_PATIENT_BY_NUMBER_ONLY,
  SEARCH_PATIENT_BY_SSN,
  SEARCH_CAREGIVER_BY_NAME,
  SEARCH_CAREGIVER_BY_NUMBER,
  SEARCH_CAREGIVER_BY_NUMBER_ONLY,
  SEARCH_CAREGIVER_BY_SSN,
  SEARCH_TRANSPORTER,
  CLEAR_SEARCH_RESULTS,
} from '../types/search';
import { PayloadAction, RESET_STATE } from '../types/global';
import { SearchType } from '../../utility/enumerations';

export interface SearchState {
  searchType: number,
  searchResults: any,
  searchResultsType: any
}

const INITIAL_STATE: SearchState = {
  searchType: SearchType.Patient,
  searchResults: null,
  searchResultsType: null,
};

const searchReducer = function (state: SearchState = INITIAL_STATE, action: PayloadAction<any>): SearchState {
  switch (action.type) {
    case RESET_STATE:
      return INITIAL_STATE;
    case CLEAR_SEARCH_RESULTS:
      return { ...state, searchResults: null };
    case SET_SEARCH_TYPE:
      return { ...state, searchType: action.payload };
    case SEARCH_PATIENT_BY_NAME:
      return { ...state, searchResults: action.payload, searchResultsType: SearchType.Patient };
    case SEARCH_PATIENT_BY_NUMBER:
      return { ...state, searchResults: action.payload, searchResultsType: SearchType.Patient };
    case SEARCH_PATIENT_BY_NUMBER_ONLY:
      return { ...state, searchResults: action.payload, searchResultsType: SearchType.Patient };
    case SEARCH_PATIENT_BY_SSN:
      return { ...state, searchResults: action.payload, searchResultsType: SearchType.Patient };
    case SEARCH_CAREGIVER_BY_NAME:
      return { ...state, searchResults: action.payload, searchResultsType: SearchType.Caregiver };
    case SEARCH_CAREGIVER_BY_NUMBER:
      return { ...state, searchResults: action.payload, searchResultsType: SearchType.Caregiver };
    case SEARCH_CAREGIVER_BY_NUMBER_ONLY:
      return { ...state, searchResults: action.payload, searchResultsType: SearchType.Caregiver };
    case SEARCH_CAREGIVER_BY_SSN:
      return { ...state, searchResults: action.payload, searchResultsType: SearchType.Caregiver };
    case SEARCH_TRANSPORTER:
      return { ...state, searchResults: action.payload, searchResultsType: SearchType.Transporter };
    default:
      return state;
  }
};

export default searchReducer;
